var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlt2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 11.5833C7.75 11.7967 7.70822 12.008 7.62704 12.2052C7.54586 12.4023 7.42687 12.5815 7.27687 12.7324C7.12686 12.8833 6.94878 13.003 6.7528 13.0846C6.55681 13.1663 6.34675 13.2083 6.13462 13.2083C5.70619 13.2083 5.29531 13.0371 4.99237 12.7324C4.68942 12.4276 4.51923 12.0143 4.51923 11.5833M7.75 11.5833C7.75 11.3699 7.70822 11.1586 7.62704 10.9615C7.54586 10.7643 7.42687 10.5852 7.27687 10.4343C7.12686 10.2834 6.94878 10.1637 6.7528 10.082C6.55681 10.0004 6.34675 9.95833 6.13462 9.95833M7.75 11.5833H14.75M6.13462 9.95833C5.70619 9.95833 5.29531 10.1295 4.99237 10.4343C4.68942 10.739 4.51923 11.1524 4.51923 11.5833M6.13462 9.95833V0.75M4.51923 11.5833H0.75M14.75 11.5833L12.5962 9.41667M14.75 11.5833L12.5962 13.75M6.13462 0.75L10.9808 3.45833L6.13462 6.16667V0.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlt2);
export default __webpack_public_path__ + "static/media/flt2.206b4c918042bf6ba0db8e9f33600e3a.svg";
export { ForwardRef as ReactComponent };